import Dropdown from 'react-bootstrap/Dropdown';
import { logoutApi } from '../../api/user/UserApi';
import useGoToNavigation from '../../util/useGotoNavigation';
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../util/userContext/UserContext';
import { useEffect } from 'react';
import { useBreadcrumbs } from './menus/useBreadcrumbs';


export const Header = () => {
    const navigate = useNavigate();
    const { goToNavigation } = useGoToNavigation();
    const { user, login, logout } = useUser();

    const breadcrumbs = useBreadcrumbs(window.location.pathname)

    const logoutAPiMutate = useMutation({
        mutationFn: () => logoutApi(),
        onSuccess: res => {
            if (res.data.code === "0000") {
                logout()
                goToNavigation('login', "", false)
                sessionStorage.setItem("openMenus", "{\"order\":true,\"customer\":true,\"support\":true,\"purchase\":true}")
            }
        },
        onError: res => {
            alert(res)
        }
    });

    useEffect(() => {
        if (localStorage.getItem('mdstech_accessToken')) {
            const data = {
                accessToken: localStorage.getItem('mdstech_accessToken')
            }
            login(data as any)
        } else {
            goToNavigation('', '', false)
        }
    }, []);

    const isBackIcon = () => {
        const flag = (window.location.pathname.indexOf("/detail") >= 0
            || window.location.pathname.indexOf("/history") >= 0
            || window.location.pathname.indexOf("/create") >= 0
            || window.location.pathname.indexOf("/edit") >= 0
            || window.location.pathname.indexOf("/update") >= 0
            || window.location.pathname.indexOf("/column") >= 0
            || window.location.pathname.indexOf("/expected") >= 0
            || window.location.pathname.indexOf("/sales/company") >= 0
        )

        return flag
    }

    return (
        <div className="header-container">
            <div className="header_outer">
                <div className="header_title">
                    {isBackIcon() && (
                        <img
                            className="me-15px clickable"
                            src={process.env.PUBLIC_URL + "/assets/images/icon_back.png"}
                            alt=""
                            width={20}
                            height={15.8}
                            onClick={() => navigate(-1)}
                        />
                    )}
                    {breadcrumbs.sub}
                    {window.location.pathname.indexOf("/dashboard") >= 0 && !window.location.pathname.includes("/edit") && (
                        <img
                            className="ms-10px clickable"
                            src={process.env.PUBLIC_URL + "/assets/images/ico_setting.png"}
                            alt=""
                            width={27}
                            height={27}
                            onClick={() => goToNavigation("main/dashboard/edit", "", false)}
                        />
                    )}
                </div>
                <div className="header-breadcrumb">
                    <div>{breadcrumbs.main}</div>
                    <div>
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_breadcrumb_arrow.png"} alt="" />
                    </div>
                    <div>{breadcrumbs.sub}</div>
                </div>
            </div>

            <div className="header_toolbar">
                <ul>
                    <li>
                        <span>{user?.userName}</span> {user?.loginId}
                    </li>
                    <li>
                        <Dropdown className="dd_user">
                            <Dropdown.Toggle variant="link">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_user_header.png"}
                                    alt=""
                                    onClick={() => goToNavigation("manage/mypage", "", false)}
                                />
                            </Dropdown.Toggle>
                        </Dropdown>
                    </li>
                    <li>
                        <div className="header_divider"></div>
                    </li>
                    <li>
                        <a
                            className="btn btn-link btn_logout"
                            onClick={() => logoutAPiMutate.mutate()}
                        >
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/icon_header_logout.png"}
                                alt=""
                            />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};
